import React from "react";
import "./report-page-header.css";

interface ReportPageHeaderProps {
  icon: string;
  title: string;
  subtitle: string;
  filterLabel?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

const ReportPageHeader: React.FC<ReportPageHeaderProps> = ({
  icon,
  title,
  subtitle,
  filterLabel = "Filter",
  actions,
  children,
  className = "",
  contentClassName = "",
}) => {
  return (
    <div className={`report-page-header card p-4 w-full ${className}`.trim()}>
      <div className="report-page-header__hero">
        <div className="report-page-header__hero-main">
          <div className="report-page-header__icon">
            <i className={`pi ${icon}`} />
          </div>
          <div>
            <h2 className="report-page-header__title">{title}</h2>
            <p className="report-page-header__subtitle">{subtitle}</p>
          </div>
        </div>
        {actions ? (
          <div className="report-page-header__hero-actions">{actions}</div>
        ) : null}
      </div>

      {children ? (
        <>
          <div className="report-page-header__filter-title">
            <i className="pi pi-filter" />
            <span>{filterLabel}</span>
          </div>
          <div className={`report-page-header__content ${contentClassName}`.trim()}>
            {children}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ReportPageHeader;
